var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.667 6.00033H23.3337V16.667C23.3337 17.4003 22.7337 18.0003 22.0003 18.0003H6.00033V19.3337C6.00033 20.8003 7.20033 22.0003 8.66699 22.0003H22.0003L27.3337 27.3337V8.66699C27.3337 7.20033 26.1337 6.00033 24.667 6.00033ZM20.667 12.667V3.33366C20.667 1.86699 19.467 0.666992 18.0003 0.666992H3.33366C1.86699 0.666992 0.666992 1.86699 0.666992 3.33366V20.667L6.00033 15.3337H18.0003C19.467 15.3337 20.667 14.1337 20.667 12.667Z",
    fill: "#5F6CE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBlue);
export default __webpack_public_path__ + "static/media/chatBlue.1cb7d38c26b482e15dc90d3f331d1bf5.svg";
export { ForwardRef as ReactComponent };